export default __webpack_public_path__ + "static/santa4d57063c84061a-58229e89bf083b73621fb5d3519ce016.png";